var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandelerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.99665C0 3.58022 3.58022 0 7.99665 0C12.4131 0 15.9933 3.58022 15.9933 7.99665C15.9933 12.4131 12.4131 15.9933 7.99665 15.9933C3.58022 15.9933 0 12.4131 0 7.99665Z",
    fill: "#FEF3C6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1250_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.24121 7.24693V5.37286C7.24121 5.27345 7.2807 5.17812 7.35099 5.10783C7.42128 5.03754 7.51662 4.99805 7.61603 4.99805H8.36565C8.46506 4.99805 8.5604 5.03754 8.63069 5.10783C8.70098 5.17812 8.74047 5.27345 8.74047 5.37286V7.24693",
    stroke: "#E17100",
    strokeWidth: 0.749628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74023 5.74756C9.33668 5.74756 9.90869 5.98449 10.3304 6.40624C10.7522 6.82799 10.9891 7.4 10.9891 7.99644V9.12089",
    stroke: "#E17100",
    strokeWidth: 0.749628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99219 9.12089V7.99644C4.99219 7.4 5.22912 6.82799 5.65087 6.40624C6.07262 5.98449 6.64463 5.74756 7.24107 5.74756",
    stroke: "#E17100",
    strokeWidth: 0.749628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3646 9.12109H4.61798C4.41097 9.12109 4.24316 9.2889 4.24316 9.49591V10.2455C4.24316 10.4525 4.41097 10.6204 4.61798 10.6204H11.3646C11.5716 10.6204 11.7394 10.4525 11.7394 10.2455V9.49591C11.7394 9.2889 11.5716 9.12109 11.3646 9.12109Z",
    stroke: "#E17100",
    strokeWidth: 0.749628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1250_1050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.99554,
    height: 8.99554,
    fill: "white",
    transform: "translate(3.49316 3.49878)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandelerIcon);
export default __webpack_public_path__ + "static/media/handeler_icon.fa2ce7625c9a83bf2e53030bdc7e37a2.svg";
export { ForwardRef as ReactComponent };